import React from 'react';
import { Slider, SliderTrack, SliderFilledTrack, SliderThumb, Box, Flex, Tooltip, FormLabel } from '@chakra-ui/react';
import _ from 'lodash';
import { useCallback } from 'react';
import { updateComponent } from '../../redux/pagesSlice';
import { selectComponent, selectedComponent } from '../../redux/selectedComponentSlice';
import { selectedPage } from '../../redux/selectedPageSlice';
import { useDispatch, useSelector } from 'react-redux';
import { findCompByIdRecursively } from '../../utils/functions';
import { UilQuestionCircle } from '@iconscout/react-unicons';

export const getMaxWidthValue = ({ propValue, maxSize = 100, step = 1 }) => {
	return getSliderValues({ propValue, maxSize, step });
};

export const getMaxWidthValues = ({ propValue, maxSize = 100 }) => {
	return getSliderValues({ propValue, maxSize });
};

const getSliderValues = ({ propValue, maxSize = 11, step = 1, minSize = 0 }) => {
	return [{ propValue, maxSize, step, minSize }];
};

const EditorSlider = ({ propName, tooltip, title, values, componentId, arrayIndex, originalPropname }) => {
	const [options, setOptions] = React.useState({ title, values });
	const selectedPageValue = useSelector(selectedPage);
	const selectedComponentValue = useSelector(selectedComponent);
	const dispatch = useDispatch();
	const debounceFn = useCallback(_.debounce(handlePagesUpdate, 250), [
		selectedPageValue,
		componentId,
		selectedComponentValue,
	]);

	function handlePagesUpdate(value) {
		const newSelectedComponent = JSON.parse(JSON.stringify(selectedComponentValue));
		const { comp } = findCompByIdRecursively([newSelectedComponent?.props], componentId);
		if (typeof comp.props[propName] === 'object') {
			comp.props[propName][title] = value;
		} else if (originalPropname) {
			if (typeof comp.props[originalPropname][arrayIndex][propName] === 'object') {
				comp.props[originalPropname][arrayIndex][propName][title] = value;
			} else {
				comp.props[originalPropname][arrayIndex][propName] = value;
			}
		} else {
			comp.props[propName] = value;
		}
		dispatch(
			updateComponent({
				component: comp,
				componentId,
				pageId: selectedPageValue,
			}),
		);

		if (newSelectedComponent?.childComp) {
			const { comp: originalComp } = findCompByIdRecursively([newSelectedComponent?.props], componentId);
			originalComp.props = JSON.parse(JSON.stringify(comp.props));
		}

		//precisa disso pro componente renderizar corretamente se alterar + de 1 prop
		dispatch(selectComponent(newSelectedComponent));
	}

	function handleChange(e) {
		let value = e;
		const newOptions = JSON.parse(JSON.stringify(options));
		newOptions.values[0].propValue = value;
		if (propName == 'maxWidth') {
			value = value + '%';
		}
		setOptions(newOptions);
		debounceFn(value);
	}

	function getValue(value) {
		if (value == 11) return '256px';
		if (value == 10) return '128px';
		if (value == 9) return '64px';
		if (value == 8) return '48px';
		if (value == 7) return '32px';
		if (value == 6) return '24px';
		if (value == 5) return '16px';
		if (value == 4) return '12px';
		if (value == 3) return '8px';
		if (value == 2) return '4px';
		if (value == 1) return '2px';
		if (value == 0) return '0px';
		return value;
	}

	return (
		<Flex className="mz-hef-edit" flex={'1 1 49%'} maxW={'49%'} flexDir="column">
			<label
				className="mz-hef-edit-label"
				d={'flex'}
				alignItems={'center'}
				justifyContent={'space-between'}
				mr={0}
				borderColor={'gray.200'}
				fontFamily={'Poppins'}
				color={'gray.700'}
				fontWeight="bold"
				fontSize={'sm'}
			>
				<Box display={'inline-block'}>{options.title}</Box>
				{/* {!!tooltip && 
                <Tooltip fontSize='xs' label={tooltip}>
                    <Box display={'inline-block'} >
                        <UilQuestionCircle size='16' />
                    </Box>
                </Tooltip>} */}
			</label>
			<Box gap={3} display="flex">
				<Slider
					size={'sm'}
					onChange={(e) => {
						handleChange(e);
					}}
					min={options.values[0].minSize}
					max={options.values[0].maxSize}
					step={options.values[0].step}
					defaultValue={options.values[0].propValue}
				>
					<SliderTrack>
						<SliderFilledTrack bg={'yellow.400'} />
					</SliderTrack>
					<SliderThumb boxSize={4} overflow="hidden">
						<Box backgroundColor={'#CBD5E0'} w={'100%'} h={'100%'} />
					</SliderThumb>
				</Slider>
				<Box minW={'32px'} fontSize={'xs'} fontWeight={'normal'}>
					{getValue(options.values[0].propValue)}
				</Box>
			</Box>
		</Flex>
	);
};

export default EditorSlider;
